import { useEffect, useState } from "react";

// Canonical breakpoints shared by CSS (see global.css header comment) and JS.
export const BREAKPOINTS = { xs: 480, sm: 768, md: 960, lg: 1100 };

export function isMobileViewport(breakpoint = BREAKPOINTS.md) {
  return typeof window !== "undefined" && window.innerWidth <= breakpoint;
}

export function useMediaQuery(query) {
  const getMatches = () =>
    typeof window !== "undefined" && typeof window.matchMedia === "function"
      ? window.matchMedia(query).matches
      : false;

  const [matches, setMatches] = useState(getMatches);

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const mq = window.matchMedia(query);
    const onChange = (e) => setMatches(e.matches);
    setMatches(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}

export function useIsMobile(breakpoint = BREAKPOINTS.md) {
  return useMediaQuery(`(max-width: ${breakpoint}px)`);
}
